import React, { useState } from 'react';
import RModal from '../../Rsuite/Modal';
import { CustomInput } from '../../CustomInput';
import { CustomInputCurrency } from '../../CustomInputCurrency';
import { Label } from '../../Label';
import { CustomButton } from '../../CustomButton';
import * as S from './styles';
import { useRef } from 'react';
import { Message, toaster } from 'rsuite';
import api from '../../../services/api';
import { useAuth } from '../../../hooks/auth';
import { FaTrashAlt } from 'react-icons/fa';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { ImageUploader } from '../../ImageUploader';
import { toastError, toastSuccess } from '../../../toasts';
import { Spacer } from '../../Spacer';
import { IMAGES_PATH } from '../../../utils/imagesPath';

export const CreatEdit = ({
  open = false,
  close = () => {},
  currentGroupId,
  currentAdditional,
  handleAddAdditional,
  handleEditAdditional,
  handleRemoveAdditional,
  getAdditionals,
  setCurrentAdditional,
}) => {
  const { id_empresa } = useAuth();
  const descriptionRef = useRef(null);
  const codigoPdvRef = useRef(null);
  const priceRef = useRef(null);
  const { theme } = useCustomTheme();
  const [additionalImage, setAdditionalImage] = useState(null);

  function handleSubmit() {
    const description = descriptionRef.current.value.trim();
    const codigoPdv = Number(codigoPdvRef.current.value);
    const price = parseFloat(priceRef.current.value.trim());

    if (
      !description ||
      typeof price !== 'number' ||
      Number.isNaN(price) ||
      typeof codigoPdv !== 'number' ||
      Number.isNaN(codigoPdv)
    ) {
      toaster.push(
        <Message showIcon type="error">
          Preencha os campos corretamente.
        </Message>,
      );
      return;
    }

    if (!!currentAdditional?.Id) {
      editAdditional(description, price, codigoPdv);
      return;
    }

    createAdditional(description, price, codigoPdv);
  }

  async function createAdditional(description, price, codigoPdv) {
    try {
      const productAdditional = {
        IsAdicional: true,
        Descricao: description,
        CodigoPDV: codigoPdv,
        Unidade: 'UN',
        TipoProduto: 'ADICIONAL',
        Grupo: currentGroupId,
        IdEmpresa: id_empresa,
        Composicao: '',
        PrecoVenda: price,
        MontagemPrato: 0,
        Fracionado: 0,
        KgInicial: 0,
        FreteGratis: 0,
        Sequencia: 0,
        QtdMinima: 0,
      };

      const resopnse = await api.post(`/produto/criar`, productAdditional);

      if (resopnse.status !== 201) {
        toaster.push(
          <Message showIcon type="error">
            Não foi possivel criar adicional.
          </Message>,
        );
        return;
      }

      saveImage(additionalImage, resopnse.data);
      handleAddAdditional(resopnse.data);
      close();
    } catch (err) {
      console.log(err);
    }
  }

  async function editAdditional(description, price, codigoPdv) {
    const productAdditional = {
      Descricao: description,
      PrecoVenda: price,
      CodigoPDV: codigoPdv,
    };

    try {
      const response = await api.patch(
        `/produto/alterar/${currentAdditional.Id}`,
        productAdditional,
      );

      if (response.status !== 200) {
        toaster.push(
          <Message showIcon type="error">
            Não foi possivel editar adicional.
          </Message>,
        );
        return;
      }

      handleEditAdditional(response.data);
      close();
    } catch (err) {
      console.log(err);
    }
  }

  async function removeAdditional() {
    try {
      const response = await api.patch(
        `/produto/alterar/${currentAdditional.Id}`,
        {
          Ativo: false,
        },
      );

      if (response.status !== 200) {
        toaster.push(
          <Message showIcon type="error">
            Não foi possivel editar adicional.
          </Message>,
        );
        return;
      }

      handleRemoveAdditional(currentAdditional.Id);
      close();
    } catch (err) {
      console.log(err);
    }
  }

  const saveImage = async (image, createdAdditional) => {
    if (!currentAdditional && !createdAdditional) {
      setAdditionalImage(image);
      return;
    }

    try {
      const additionalId = createdAdditional
        ? createdAdditional.Id
        : currentAdditional.Id;

      const imageSizeMB = image?.size / 1024 / 1024;

      if (imageSizeMB > 1) {
        toastError('Imagem com tamanho maior que o permitido!');
        return;
      }

      const fd = new FormData();
      fd.append('IdEmpresa', id_empresa);
      fd.append('Id', additionalId);
      fd.append('image', image);

      const res = await api.post('produto/alterarFoto', fd);

      toastSuccess('Imagem salva com sucesso!');
      getAdditionals(currentGroupId);

      if (!createdAdditional) {
        setCurrentAdditional(res.data);
      }
    } catch (err) {
      toastError('Não foi possivel salvar imagem');
    }
  };

  const removeImage = async () => {
    try {
      const fd = new FormData();
      fd.append('IdEmpresa', id_empresa);
      fd.append('ColunaImagem', 'Imagem');
      fd.append('Id', currentAdditional.Id);
      const res = await api.post('produto/excluirFoto', fd);

      toastSuccess('A imagem foi apagada!');
      getAdditionals(currentGroupId);
      setCurrentAdditional(res.data);
    } catch (err) {
      toastError('Não foi possivel remover imagem');
    }
  };

  const imageUrl = (() => {
    let url = '';

    if (currentAdditional?.Imagem) url = IMAGES_PATH + currentAdditional.Imagem;

    if (additionalImage) url = URL.createObjectURL(additionalImage);

    return url;
  })();

  return (
    <RModal
      open={open}
      onClose={close}
      title={
        !!currentAdditional?.Id ? 'Editar Adicional' : 'Cadastrar Adicional'
      }
      size="md"
      footer={
        <S.Footer>
          {!!currentAdditional?.Id ? (
            <CustomButton appearance="ghost" color='red' onClick={removeAdditional}>
              <FaTrashAlt
                size={20}
                color={theme.colors.danger}
                style={{ marginRight: 4 }}
              /> Apagar
            </CustomButton>
          ): <div/>}

          <div>
            <CustomButton appearance="default" onClick={close}>
              Fechar
            </CustomButton>
            <CustomButton onClick={handleSubmit}>Salvar</CustomButton>
          </div>
        </S.Footer>
      }
    >
      <Spacer y={10} />

      <S.Row style={{ alignItems: 'center' }}>
        <ImageUploader save={saveImage} remove={removeImage} src={imageUrl} />

        <Spacer x={6} />

        <S.Content>
          <S.InputGroup>
            <Label>Descrição</Label>
            <CustomInput
              placeholder="Descriçao"
              inputRef={descriptionRef}
              defaultValue={currentAdditional?.Descricao ?? ''}
            />
          </S.InputGroup>
          <S.Row>
            <S.InputGroup>
              <Label>Codigo Pdv</Label>
              <CustomInput
                placeholder="codPdv"
                inputRef={codigoPdvRef}
                defaultValue={currentAdditional?.CodigoPDV ?? ''}
              />
            </S.InputGroup>
            <S.InputGroup>
              <Label>Preço</Label>
              <CustomInputCurrency
                placeholder=""
                inputRef={priceRef}
                defaultValue={
                  currentAdditional?.PrecoVenda
                    ? +currentAdditional?.PrecoVenda
                    : 0
                }
              />
            </S.InputGroup>
          </S.Row>
        </S.Content>
      </S.Row>
    </RModal>
  );
}
